import { Component } from 'react';
import {
  Image,
  MenuItem,
  Nav,
  NavDropdown,
  NavItem,
  Navbar
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  resetApp,
  resetLast5ListenedDocuments,
  setPlayingDocumentId
} from '../../redux/actions/app-actions';
import { resetFlags } from '../../redux/actions/flag-actions';
import { setExpand } from '../../redux/actions/pdf-actions';
import { resetPlayer } from '../../redux/actions/player-actions';
import { signOutUser } from '../../redux/actions/user-actions';
import { CONSTANTS } from '../../constants/constants';
import { firebase } from '../../firebase';
import Button from '../ui/button/Button';
import {
  isUserStatusFree,
  isUserStatusSubscribed
} from '../../utils/CheckUserStatus';
import { isSubscriptionTypeBasic } from '../../utils/CheckSubscriptionType';
import { checkUserSubscription } from '../../utils/checkSubscription';

const UploadButton = styled(Button)`
  display: inline-block;
`;

class NavBar extends Component {
  logout = () => {
    var $this = this;
    this.props.dispatch(resetApp());
    this.props.dispatch(resetFlags());
    this.props.dispatch(resetLast5ListenedDocuments());
    this.props.dispatch(resetPlayer());
    this.props.dispatch(setPlayingDocumentId(null));
    this.props.dispatch(setExpand(false));
    firebase.auth.signOut().then(function() {
      $this.props.dispatch(signOutUser());
    });
  };

  render() {
    const userStatus = this.props.userStatus;
    const subscriptionType = this.props.subscriptionType;
    const isPersonalPodcastOwner = this.props.podcastUser?.isOwner;
    const isActiveSubscription = checkUserSubscription(
      this.props.mysubscriptions,
      this.props.podcastUser?.endDateTrialTime
    );

    return (
      <Navbar>
        <Navbar.Header>
          <Navbar.Brand>
            <LinkContainer
              exact
              to={
                isSubscriptionTypeBasic(subscriptionType)
                  ? '/openstax'
                  : '/dashboard'
              }
            >
              <Image src={CONSTANTS.swalLogo} />
            </LinkContainer>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          {(isUserStatusFree(userStatus) ||
            isUserStatusSubscribed(userStatus)) &&
          !isSubscriptionTypeBasic(subscriptionType) &&
          isActiveSubscription ? (
            <>
              <Nav pullRight>
                {isPersonalPodcastOwner && (
                  <LinkContainer exact to="/uploadPdf">
                    <NavItem>
                      <UploadButton
                        onClick={this.openUploadModal}
                        className="nav-special-cta"
                      >
                        Upload PDF
                      </UploadButton>
                    </NavItem>
                  </LinkContainer>
                )}
                <NavDropdown
                  title={
                    <i
                      className="fa fa-user-circle user-avatar"
                      aria-hidden="true"
                    />
                  }
                  id="basic-nav-dropdown"
                >
                  <LinkContainer to="/myprofile">
                    <MenuItem>My account</MenuItem>
                  </LinkContainer>
                  <MenuItem onClick={this.logout}>Sign out</MenuItem>
                </NavDropdown>
              </Nav>
              <Nav>
                <LinkContainer exact to="/dashboard">
                  <NavItem>
                    <span className="underline-deco">Dashboard</span>
                  </NavItem>
                </LinkContainer>
                <LinkContainer exact to="/discover">
                  <NavItem>
                    <span className="underline-deco">Discover</span>
                  </NavItem>
                </LinkContainer>
                <LinkContainer exact to="/flags">
                  <NavItem>
                    <span className="underline-deco">Search Flags</span>
                  </NavItem>
                </LinkContainer>
              </Nav>
            </>
          ) : (
            <Nav pullRight>
              <NavDropdown
                title={
                  <i
                    className="fa fa-user-circle user-avatar"
                    aria-hidden="true"
                  />
                }
                id="basic-nav-dropdown"
              >
                <LinkContainer to="/myprofile">
                  <MenuItem>My account</MenuItem>
                </LinkContainer>
                <MenuItem onClick={this.logout}>Sign out</MenuItem>
              </NavDropdown>
            </Nav>
          )}
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    podcastUser: store.user.podcastUser,
    firebaseInfo: store.user.firebaseInfo,
    mysubscriptions: store.user.mysubscriptions
  };
};

export default connect(mapStateToProps)(withRouter(NavBar));
